import { api } from '@/utils/apiService';

function isBonusSaveSuccess(res) {
  const code = res?.data?.code;
  return code === 200 || code === 201;
}

const bonus = {
  namespaced: true,
  state: {
    bonusList: [],
    bonusStats: {},
  },
  mutations: {
    SET_BONUS_LIST: (state, list) => {
      state.bonusList = Array.isArray(list) ? list : [];
    },
    SET_BONUS: (state, item) => {
      const idx = state.bonusList.findIndex(b => b.bonusID === item.bonusID);
      if (idx === -1) state.bonusList.push(item);
      else state.bonusList.splice(idx, 1, item);
    },
    REMOVE_BONUS: (state, bonusID) => {
      state.bonusList = state.bonusList.filter(b => b.bonusID !== bonusID);
    },
    SET_BONUS_STATS: (state, { bonusID, stats }) => {
      state.bonusStats = { ...state.bonusStats, [bonusID]: stats };
    },
  },
  actions: {
    fetchBonus: async ({ commit }) => {
      try {
        const res = await api.get('/bonus');
        if (res?.status === 200 && Array.isArray(res.data)) {
          commit('SET_BONUS_LIST', res.data);
          return res.data;
        }
        commit('SET_BONUS_LIST', []);
        return [];
      } catch (e) {
        console.error('fetchBonus:', e);
        commit('SET_BONUS_LIST', []);
        return [];
      }
    },
    saveBonus: async ({ dispatch }, params) => {
      const bonusID = params.bonusID || 0;
      const res = await api.patch(`/bonus/${bonusID}`, params);
      if (!isBonusSaveSuccess(res)) {
        const err = new Error('Bonus save failed');
        err.code = res?.data?.code;
        err.reason = res?.data?.reason;
        throw err;
      }
      await dispatch('fetchBonus');
      return res;
    },
    deleteBonus: async ({ commit }, bonusID) => {
      try {
        const res = await api.delete(`/bonus/${bonusID}`);
        commit('REMOVE_BONUS', bonusID);
        return res;
      } catch (e) {
        console.error('deleteBonus:', e);
        return null;
      }
    },
    fetchBonusStats: async ({ commit }, bonusID) => {
      try {
        const res = await api.get(`/bonus/${bonusID}/stats`);
        if (res?.status === 200 && res.data) {
          commit('SET_BONUS_STATS', { bonusID, stats: res.data });
          return res.data;
        }
        return null;
      } catch (e) {
        console.error('fetchBonusStats:', e);
        return null;
      }
    },
    windDownBonus: async ({ dispatch }, bonusID) => {
      const res = await api.post(`/bonus/${bonusID}/wind-down`);
      if (res?.data?.code !== 200) {
        const err = new Error('Wind-down failed');
        err.code = res?.data?.code;
        throw err;
      }
      await dispatch('fetchBonus');
      return res.data;
    },
    reactivateBonus: async ({ dispatch }, bonusID) => {
      const res = await api.post(`/bonus/${bonusID}/reactivate`);
      if (res?.data?.code !== 200) {
        const err = new Error('Reactivate failed');
        err.code = res?.data?.code;
        throw err;
      }
      await dispatch('fetchBonus');
      return res.data;
    },
    archiveBonus: async ({ dispatch }, bonusID) => {
      const res = await api.post(`/bonus/${bonusID}/archive`);
      if (res?.data?.code !== 200) {
        const err = new Error('Archive failed');
        err.code = res?.data?.code;
        err.openUsers = res?.data?.openUsers;
        throw err;
      }
      await dispatch('fetchBonus');
      return res.data;
    },
  },
  getters: {
    getBonusList: (state) => state.bonusList,
    getActiveBonus: (state) => state.bonusList.find(b => b.itemStatus === 0) || null,
    getWindDownBonus: (state) => state.bonusList.find(b => b.itemStatus === 2) || null,
    getManageableBonus: (state, getters) => getters.getActiveBonus || getters.getWindDownBonus,
    getBonusStats: (state) => (bonusID) => state.bonusStats[bonusID] || null,
  },
};

export default bonus;
